import { groupBy, isNull } from 'lodash';
import React, { useRef } from 'react';
import { IMarkupLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { FontFamilySelector } from '@meitu/saas-editor-ui/es/components/font-family-selector';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { getUsingFonts } from '@meitu/saas-editor-ui/es/utils/font';
import { type FontItem } from '@meitu/xdesign-widgets';
import { editor } from '@/instance';

export const LabelFontFamily: React.FC<{
    id: string;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onAfterChange, trackCode }) => {
    const usingFonts = getUsingFonts(editor, editor.services.frame.getActiveFrameId());
    const groupFonts = useRef(groupBy(editor.services.font.getFontItems(), 'category_name'));

    const res = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { label } = layer.data as IMarkupLayerProps;
        return {
            fontFamily: label.fontFamily,
        };
    });

    const onChange = async (data: FontItem) => {
        const font_name = data.font_name;
        const layer = editor.services.flatLayer.getLayer(id, true);
        editor.markupLayer.setAttrOperateOriginData(layer);
        await editor.markupLayer.setLabelFontFamily(id, font_name);
        editor.markupLayer.clearAttrOperateOriginData();
        onAfterChange?.(trackCode);
    };

    const globalWidgetRef = useGlobalWidget(editor, false);

    if (isNull(res)) return null;

    const { fontFamily } = res;

    return (
        <div className="c-markup-panel__item c-markup-label">
            <FontFamilySelector
                value={fontFamily}
                fonts={groupFonts.current}
                usingFonts={usingFonts}
                onChange={onChange}
                enableRemoteSearch={false}
                onDropdownVisibleChange={(e) => {
                    globalWidgetRef.current = e;
                }}
            />
        </div>
    );
});
